/* ÉLIANE: progressive enhancements, no third-party dependencies. */
(() => {
 'use strict';
 class CampaignVideo extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.video = this.querySelector('video');
   this.button = this.querySelector('button');
   if (!this.video || !this.button) return;
   try { this.sources = JSON.parse(this.querySelector('script').textContent); } catch (_) { return; }
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.mobile = matchMedia('(max-width: 749px)');
   this.connection = navigator.connection;
   this.visible = false;
   this.userPaused = false;
   this.button.addEventListener('click', () => {
    this.userPaused = !this.video.paused;
    if (this.userPaused) this.video.pause(); else this.play(true);
   }, {signal});
   this.video.addEventListener('playing', () => { this.classList.add('is-playing'); this.updateButton(); }, {signal});
   this.video.addEventListener('pause', () => this.updateButton(), {signal});
   this.video.addEventListener('ended', () => { this.classList.remove('is-playing'); this.updateButton(); }, {signal});
   this.video.addEventListener('error', () => { this.classList.remove('is-playing'); this.button.hidden = true; }, {signal});
   this.reset = () => {
    this.video.pause(); this.video.removeAttribute('src'); this.video.load();
    this.classList.remove('is-playing');
    this.button.hidden = !this.available() || this.blocked();
    if (this.visible) this.play(false);
   };
   this.motion.addEventListener('change', this.reset, {signal});
   this.mobile.addEventListener('change', this.reset, {signal});
   this.connection?.addEventListener('change', this.reset, {signal});
   document.addEventListener('visibilitychange', () => {
    if (document.hidden) this.video.pause(); else if (this.visible) this.play(false);
   }, {signal});
   if ('IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries => {
     this.visible = entries[0].isIntersecting;
     if (this.visible) this.play(false); else this.video.pause();
    }, {threshold:0.15});
    this.observer.observe(this);
   } else { this.visible = true; }
   this.reset();
  }
  blocked() { return this.motion.matches || this.connection?.saveData || /(^|-)2g$/.test(this.connection?.effectiveType || ''); }
  available() { return Array.isArray(this.sources[this.mobile.matches ? 'mobile' : 'desktop']) && this.sources[this.mobile.matches ? 'mobile' : 'desktop'].length > 0; }
  async play(manual) {
   if (this.blocked() || !this.available() || document.hidden || (!manual && (this.dataset.autoplay !== 'true' || this.userPaused))) return;
   if (!this.video.getAttribute('src')) {
    const sources = this.sources[this.mobile.matches ? 'mobile' : 'desktop'].filter(x => x.format === 'mp4' || x.mime_type === 'video/mp4').sort((a,b) => a.width - b.width);
    const selected = sources.find(x => x.width >= (this.mobile.matches ? 720 : 1440)) || sources[sources.length - 1];
    if (!selected) { this.button.hidden = true; return; }
    this.video.muted = true;
    this.video.src = selected.url;
   }
   try { await this.video.play(); } catch (_) { this.classList.remove('is-playing'); this.updateButton(); }
  }
  updateButton() {
   const playing = !this.video.paused && !this.video.ended;
   this.button.setAttribute('aria-label', playing ? this.dataset.labelPause : this.dataset.labelPlay);
   this.button.firstElementChild.textContent = playing ? 'Ⅱ' : '▶';
  }
  disconnectedCallback() { this.video?.pause(); this.observer?.disconnect(); this.abort?.abort(); this.abort = null; }
 }
 class Announcement extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   const button = this.querySelector('button'); if (!button) return;
   this.abort = new AbortController(); button.hidden = false;
   button.addEventListener('click', () => {
    const paused = this.classList.toggle('is-paused');
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Riprendi scorrimento' : 'Pausa scorrimento');
    button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
   }, {signal:this.abort.signal});
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; }
 }
 if (!customElements.get('el-campaign-video')) customElements.define('el-campaign-video', CampaignVideo);
 if (!customElements.get('el-announcement')) customElements.define('el-announcement', Announcement);
})();